<template>
  <div>
    <ZtLink
      v-if="teaserProps"
      :to="teaserProps.url"
      class="group flex items-stretch justify-between overflow-hidden rounded-[4px] bg-[#f1f1f1]"
    >
      <div class="p-3">
        <div class="text-size-6 font-bold leading-tight text-black">
          {{ teaserProps.title }}
        </div>
        <div
          class="link with-arrow mt-2 text-size-7 font-bold leading-none text-primary group-hover:text-primary-light"
          :data-href="teaserProps.url"
        >
          {{ teaserProps.linkTitle || $texts('teaserMore') }}
        </div>
      </div>

      <div
        v-if="teaserProps.media"
        class="relative w-1/3 shrink-0 overflow-hidden"
      >
        <MediaImage
          v-bind="teaserProps.media"
          responsive-style="column_fifth"
          image-class="object-cover absolute top-0 left-0 size-full transition group-hover:scale-110 ease-swing"
        />
      </div>
    </ZtLink>
  </div>
</template>

<script lang="ts" setup>
import type { ParagraphTeaserFragment } from '#graphql-operations'
import type { TeaserProps } from '~/components/Teaser/types'
import { buildTeaserProps } from './helper'

const props = defineProps<ParagraphTeaserFragment>()

defineBlokkli({
  bundle: 'teaser',
  globalOptions: ['bkHiddenGlobally'],
  renderFor: {
    fieldListType: 'menu',
  },
  editor: {
    previewWidth: 200,
  },
})

const teaserProps = computed<TeaserProps | null>(() => {
  if (!props) {
    return null
  }
  const teaserProps = buildTeaserProps(props)
  if (!teaserProps) {
    return null
  }

  return teaserProps
})
</script>
